import React from 'react';
import ReactDOM from 'react-dom';
import styles from './styles.module.scss';

const GlobalMask = () => ReactDOM.createPortal((
  <div
    className={styles.mask}
    onClick={(e) => e.stopPropagation()}
  />
), document.body);

export default GlobalMask;
